import { Label } from '@bpinternal/ui-kit-next'
import { ComponentProps, FC, ReactNode } from 'react'
import { cn } from '~/utils'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

export type RadioCardProps = {
  id: string
  value: string
  children?: ReactNode
  labelClassName?: string
} & ComponentProps<typeof RadioGroupPrimitive.Item>

export const RadioCard: FC<RadioCardProps> = ({ id, value, children, className, labelClassName, ...props }) => {
  return (
    <RadioGroupPrimitive.Item value={value} id={id} {...props} className={cn('group relative', className)}>
      <Label
        htmlFor={id}
        className={cn(
          'flex w-full cursor-pointer flex-col items-center justify-center rounded-lg border bg-card',
          'transition-all duration-200 hover:ring-1 hover:ring-gray-4',
          'group-data-[state=checked]:bg-accent-3 group-data-[state=checked]:ring-2 group-data-[state=checked]:ring-accent-9',
          labelClassName
        )}
      >
        {children}
      </Label>
    </RadioGroupPrimitive.Item>
  )
}
